export default {
    created() {
        document.addEventListener("click", this.clickDocument);
    },

    destroyed() {
        document.removeEventListener("click", this.clickDocument);
    },

    methods: {
        clickDocument(e) {
            if (e.target.id !== this.btnId && this.documentClickTriggered) {
                this.documentClickTriggered(e);
            }
        }
    }
};